import { makeApi } from "@zodios/core";
import { z } from "zod";

import { CreditSourceTypeSchema } from "../billingConstants";
import { BalanceTransactionsResponseSchema } from "../models";

const api = makeApi([
  {
    alias: "getBalance",
    method: "get",
    path: "/api/v1/billing/balance",
    response: z.object({
      actualBalance: z.number(),
      reservedBalance: z.number(),
      availableBalance: z.number(),
    }),
  },
  {
    alias: "getBalanceThreshold",
    method: "get",
    path: "/api/v1/billing/balance/threshold",
    response: z.object({
      threshold: z.number(),
    }),
  },
  {
    alias: "setBalanceThreshold",
    method: "put",
    path: "/api/v1/billing/balance/threshold",
    parameters: [
      {
        type: "Body",
        name: "threshold",
        schema: z.object({
          threshold: z.number().positive(),
        }),
      },
    ],
    response: z.object({
      threshold: z.number().positive(),
    }),
  },
  {
    alias: "getBalanceTransactions",
    method: "get",
    path: "/api/v1/billing/balance-transactions",
    parameters: [
      {
        type: "Query",
        name: "dateFrom",
        schema: z.string().date(),
      },
      {
        type: "Query",
        name: "dateTo",
        schema: z.string().date(),
      },
      {
        type: "Query",
        name: "sourceType",
        schema: CreditSourceTypeSchema.optional(),
      },
    ],
    response: BalanceTransactionsResponseSchema,
  },
]);

export { api };
